

import {Component, Mixins} from 'vue-property-decorator';
import {getCatalogDashboardDetails} from "../../services/catalog-service";
import LineChart from "../../components/chart/LineChart.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import QueueTableFilterPanel from "@pazion/pazion-core/src/views/queue/components/QueueTableFiltersPanel.vue";
import QueueDataTable from "@pazion/pazion-core/src/views/queue/components/QueueDataTable.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import { ALL_STATES, IQueueJobState } from "@pazion/pazion-core/src/views/queue/utils";
import PazCommandSelector from "@pazion/pazion-core/src/views/queue/components/PazCommandSelector.vue";
import PazListFilterSelector from "@pazion/pazion-core/src/components/utils/PazListFilterSelector.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import { getFlows } from '@pazion/pazion-core/src/services/auth-service';
import { IDashboardinfo } from '@pazion/pazion-catalog/src/models/base';
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import {authentication} from "@pazion/pazion-core/src/store";


interface ICache {
  [key: string]: boolean;
}

export const retryMap: ICache = {};
export const cancelMap: ICache = {};
export const inProgressMap: ICache = {};

ALL_STATES.forEach((state) => {
  retryMap[state.nameTech] = state.retry;
  cancelMap[state.nameTech] = state.cancel;
  inProgressMap[state.nameTech] = state.inProgress ?? false;
});

@Component({
  components: {
    QueueTableFilterPanel,
    LineChart,
    PazRefreshButton,
    QueueDataTable,
    PazTextSearch,
    PazCommandSelector,
    PazListFilterSelector,
    PazTooltipButton
  }
})
export default class CatalogDashboard extends Mixins(PermissionService) {

  public data: object = {};
  public loading: boolean = true;
  public ordersTodayCount: number = 0;
  public orderMonthCount: number = 0;
  public shipmentsCountEnabled: boolean = false;
  public returnsCountEnabled: boolean = false;
  public notificationMessage: string = '';
  public shipmentsMonthCount: number = 0;
  public returnsMonthPercent: number = 0;
  public salesCount: Array<string> = [];

/* queue jobs */
  public selectedStatus: IQueueJobState[] = [];

  $refs!: {
    recurringItems: QueueDataTable;
  };

  public search: string = "";
  public items: object[] = [];
  public showcommandDialog: boolean = false;
  public selectedWorker: String[] = [];
  public selectedDelegate: String[] = [];

  get isCustomer(){
    return this.hasProfileFlag('orderManagement.dashboard.orderButton');
  }

  get showQueueDialog(){
    return this.hasProfileFlag('queueManagement.dashboard');
  }

  async fetchData() {
    this.loading = true;
    const info: IDashboardinfo = await getCatalogDashboardDetails();
    //this.items = await getQueueJobs();
    this.items =  await getFlows();

    this.ordersTodayCount = parseInt(info.orderDayCount);
    this.orderMonthCount = parseInt(info.orderMonthCount);
    this.shipmentsMonthCount = parseInt(info.shipmentsMonthCount);
    this.returnsMonthPercent = parseInt(info.returnsMonthPercent);
    this.shipmentsCountEnabled = info.shipmentsCountEnabled;
    this.returnsCountEnabled = info.returnsCountEnabled;
    this.notificationMessage = info.notificationMessage;

    this.salesCount = info.salesCount;

    this.data = {
      type: 'line',
      data: {
        labels: info.salesThisWeekLegend,
        datasets: [{
          label: info.salesThisWeekLabel,
          backgroundColor: this.$vuetify.theme.currentTheme.success,
          borderColor: this.$vuetify.theme.currentTheme.success,
          data: info.salesThisWeekValues,
          fill: false,
        }, {
          label: info.salesLastWeekLabel,
          backgroundColor: this.$vuetify.theme.currentTheme.primary,
          borderColor: this.$vuetify.theme.currentTheme.primary,
          data: info.salesLastWeekValues,
          fill: false,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Orderregels per dag afgelopen 7 dagen & de vorige week'
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Week'
            }
          },
          y: {
            min: 0,
            title: {
              display: true,
              text: 'Omzet in euro\'s'
            },
            ticks: {
              precision: 2
            }
          }
        }
      }
    }
    this.loading = false;
  }

  get monthName() {

    const objDate = new Date();
    objDate.toLocaleDateString();
    const locale = navigator.language || "nl-nl";
    return objDate.toLocaleString(locale, {month: "long"});
  }

  async mounted() {
    await this.fetchData();
  }

  get showFulfilments() : boolean{
    return this.hasProfileFlag('fulfilmentManagement.show')
  }

/* queuejobs */
  check(action: string) {
    this.$refs.recurringItems.checkSelection(action);
  }

  toggle() {
    this.$nextTick(() => {
      if (this.allSelected) {
        this.selectedStatus = [];
      } else {
        this.selectedStatus = ALL_STATES.slice();
      }
    });
  }

  async showCommandList() {
    this.showcommandDialog = true;
  }

  setFilter(filter: { key: string, value: any }) {
    this[filter.key] = filter.value;
  }

  get nothingSelected() {
    if (this.loading) {
      return this.loading;
    }

    return (this.$refs.recurringItems?.getSelectedItems.length || 0) == 0;
  }

  get allSelected(): boolean {
    return this.selectedStatus && this.selectedStatus.length === ALL_STATES.length;
  }

  get someSelected(): boolean {
    return (
        (this.selectedStatus.length > 0 || this.selectedWorker.length > 0) &&
        !this.allSelected
    );
  }

  get dropdownIcon(): string {
    if (this.allSelected) {
      return "mdi-close-box";
    }
    if (this.someSelected) {
      return "mdi-minus-box";
    }
    return "mdi-checkbox-blank-outline";
  }

  get recurringItems() {
    let items = this.items;

    if (this.selectedStatus.length > 0) {
      items = items.filter((item) => this.selectedStatus.includes(item.status));
    }

    if (this.selectedWorker.length > 0) {
      items = items.filter((item) => this.selectedWorker.includes(item.worker));
    }

    if (this.selectedDelegate.length > 0) {
      items = items.filter((item) => this.selectedDelegate.includes(item.delegate));
    }
    return items;
  }

  get getJobworkers() {
    return (
        this.items &&
        this.items.map((j: any) => {
          return j.worker
              && { nameTech: j.worker, label: j.worker }
        })
    );
  }

  get getDelegateOptions() {
    return (
        this.items &&
        this.items.map((j: any) => {
          return { nameTech: j.delegate, label: j.delegate };
        })
    );
  }

  get filteredRecurringOptions() {
    return ALL_STATES.filter(
        (item) =>
            item.showInFilter &&
            (item.isRecurringOption === "Yes" || item.isRecurringOption === "Both")
    );
  }

}
